import type { AgreementType } from '@portal/flows/domain/sa/types';

/** A tab: the types a car can qualify FOR. KM catch-up adjusts an existing agreement — no tab. */
export type QualifiedType = Extract<AgreementType, 'NEW_CAR' | 'USED_CAR' | 'PROLONGING'>;
export const QUALIFIED_TYPES: readonly QualifiedType[] = ['NEW_CAR', 'USED_CAR', 'PROLONGING'];

/** A row of `GET /customer-vehicles/service-agreement-qualifications` (one car). */
export interface QualifiedVehicle {
  id: string;
  regNr: string | null;
  firstReg: string | null;
  lastKmRead?: number | null;
  customer: { id: string; name: string | null; email: string | null } | null;
  vehicleSpec: {
    id: string;
    make: string;
    model: string;
    year: number;
    type: string;
    version: string | null;
  } | null;
  activeAgreement: {
    id: string;
    status: string;
    startDate: string;
    endDate: string;
    /** The contract's total allowance. */
    kmBought: number;
  } | null;
  lastServiceVisit: { id: string; visitDate: string; kmAtVisit: number | null } | null;
  qualifiedOfferType: AgreementType | null;
  hasQualifiedOffer: boolean;
}

export interface QualifiedVehiclesQuery {
  qualifiedOfferType: QualifiedType;
  search: string;
  sortBy?: 'customer' | 'vehicle';
  sortOrder?: 'asc' | 'desc';
  /** 1-based. */
  page: number;
  limit: number;
}

/** A row of `GET /vehicle-specs`, as the change-match modal uses it. */
export interface VehicleSpecListItem {
  id: string;
  make: string;
  model: string;
  year: number;
  type: string;
  version: string | null;
}
